import { FC } from 'react'

import { getQualityBandColor } from 'partner360/components/qualityIndicator'

import { getAchievementScoreBand } from '../../../lib'

import styles from './CockpitAchievementScore.module.scss'

interface ICockpitAchievementScoreProps {
  score: number
}

/** The Achievement score circle — the same shape as the Plan Quality circle it sits beside, on the
 *  Achievement score's own thresholds. `getAchievementScoreBand` decides the band, and the circle's
 *  color follows from it. */
export const CockpitAchievementScore: FC<ICockpitAchievementScoreProps> = ({ score }) => {
  const band = getAchievementScoreBand(score)

  return (
    <div className={styles.root}>
      <div
        className={styles.circle}
        style={{ backgroundColor: band ? getQualityBandColor(band) : undefined }}
      >
        {score}
      </div>
    </div>
  )
}

CockpitAchievementScore.displayName = 'CockpitAchievementScore'
